export const FooterCategories = [
  {
    key: 1,
    name: 'Overzicht',
    links: [
      {text: 'Producten', 'address': '/products'},
      {text: 'Toepassingen', address: '/industries'},
      //'Blog',
      {text: 'Prijs', address: '/pricing'},
      {text: 'Ontwikkelaars', address: '/developers'},
      {text: 'Help & Guides', address: '/help-and-guides'}
    ]
  },
  {
    key: 2,
    name: 'About Us',
    nameAddress: '/our-story',
    links: [
     {text: 'Our Story', address: '/our-story'},
     {text: 'Team', address: '/team'},
     {text: 'Press Kit (English)', address: '/press'},
     {text: 'Pers (Nederlands)', address: '/pers'},
      //'Blog',
      //'Career'
      {text: 'Contact Us', address: '/contact'}
    ]
  },
  {
    key: 3,
    name: 'Help',
    nameAddress: '/help-and-guides',
    links: [
      {text: 'Get Started', address: '/help-and-guides#get-started'},
      {text: 'Importance of AQ (monitoring)', address: '/help-and-guides#importance-of-air-quality'},
      {text: 'Interpreting Air Quality', address: '/help-and-guides#how-we-help-interpreting-air-quality'},
      {text: 'How good is aircheckr', address: '/help-and-guides#how-good-is-aircheckr'},
      {text: 'aircheckr Legal', address: '/help-and-guides#aircheckr-legal'}
    ]
  },
  {
    key: 4,
    name: 'Ontwikkelaars',
    nameAddress: '/developers',
    links: [
      {text: 'Basics', address: '/developers'},
      {text: 'API Documentation', address: 'https://www.aircheckr.com/api_docs', isExternal: true}
      //'Widget'
    ]
  },
  {
    key: 5,
    name: 'Domeinen',
    nameAddress: '/industries',
    links: [
      {text: 'Huis & Kantoor', address: '/industries/homeandoffice'},
      {text: 'Informatief', address: '/industries/info'},
      {text: 'Outdoor', address: '/industries/outdoor'},
      {text: 'Digitale gezondheid', address: '/industries/health'},
      {text: 'Automobiel', address: '/industries/auto'},
      {text: 'Intelligence', address: '/industries/intelli'}
    ]
  }
];

export const FooterSocialText = {
  title: 'Hou me op de hoogte',
  follow: 'Volg ons:',
  subscribe: 'Inschrijven'
}

export const Copyright = {
  contact: {
    text: 'Contacteer Ons',
    address: '/contact'
  },
  termsOfUse: {
    text: 'Terms of Use',
    linkAddress: 'https://legal.nazka.be/docs/en/terms-of-use/'
  }
}

export default FooterCategories;



// WEBPACK FOOTER //
// ./src/input-text/nl/footer.js